import * as d3 from "d3";

export const FEATURE_CARD_MIN_HEIGHT = 250;

export const FEATURE_CARD_DEFAULT_COLORS = d3.schemeAccent;

export const FEATURE_CARD_OTHER_COLOR = "#D4DADD";

export const DEFAULT_PIECHART_RADIUS = 0.6;

export const DEFAULT_BARCHART_RADIUS = 2;

export const DEFAULT_CHART_WIDTH = 154;

export const MAX_CHART_WIDTH = 300;

export const DEFAULT_CHART_ANGLE = 4;

export const DEFAULT_CHART_HEIGHT = 90;

export const FILTER_PREFIX = "%";

export const FILTERED_VALUE_OPACITY = 28;

export const DEFAULT_ATTRIBUTE_NAME = "name";

export const DEFAULT_DATA_SOURCE_LIMIT = 52;

export const YANDEX_API_KEY = "bb9b6eee-e70d-4670-844e-2571919d0c14";
